import axios from 'axios';
import {
  LOADING_ABSTRACT,
  RECEIVED_ABSTRACT,
  RECEIVED_ABSTRACT_FAILED,
} from '../types';
import { createUrl, actionObj } from '../utils';

export const fetchAbstractById = (idType, id) => async (dispatch, getState) => {
  const { token } = getState();
  const url = createUrl(`/enhancements/article/${idType}/${encodeURIComponent(id)}/abstracts?token=${token}`);

  dispatch(actionObj(LOADING_ABSTRACT, { id, idType }));

  return axios.get(url)
    .then(({ data }) => actionObj(RECEIVED_ABSTRACT, { id, idType, data: data || {} }))
    .catch(() => actionObj(RECEIVED_ABSTRACT_FAILED, { id, idType }))
    .then(dispatch);
};

const idTypes = ['pii', 'eid', 'doi'];

// eslint-disable-next-line consistent-return
export default function fetchAbstract(ids) {
  const idType = idTypes.find(typeName => !!ids[typeName]);
  if (idType) {
    return fetchAbstractById(idType, ids[idType]);
  }
}
